import { Link, useLocation } from "react-router-dom";
import { NAV } from "@/constants/testIds/clinic";

/**
 * Mobile sticky bottom CTA — full-width on phones now that the
 * Emergent badge has been removed.
 */
export default function StickyMobileCTA() {
    const { pathname } = useLocation();
    if (pathname === "/apply") return null;
    if (pathname.startsWith("/admin")) return null;

    return (
        <div className="lg:hidden fixed bottom-0 inset-x-0 z-30 pointer-events-none">
            <div
                className="pointer-events-auto px-4 pt-3 pb-3"
                style={{
                    background:
                        "linear-gradient(to top, hsl(var(--bg-chalk)) 60%, hsl(var(--bg-chalk) / 0))",
                    borderTop: "1px solid hsl(var(--border-stone))",
                    backdropFilter: "blur(8px)",
                    WebkitBackdropFilter: "blur(8px)",
                }}
            >
                <Link
                    to="/apply"
                    data-testid={NAV.stickyApplyCta}
                    className="ihx-btn-primary w-full justify-center"
                >
                    Apply for Consultation
                    <span className="ihx-arrow" aria-hidden>→</span>
                </Link>
            </div>
        </div>
    );
}
